import { useContext } from 'react';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBSeparator } from '@shared/components/list';
import { Colors } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { ReadMarkerContext } from './readMarkerContext';

export function MBChatReadMarker() {
  const registerReadMarker = useContext(ReadMarkerContext);

  return (
    <View row center padding={1} ref={registerReadMarker}>
      <View flex>
        <MBSeparator color={Colors.v2.red} />
      </View>
      <View paddingHorizontal={1}>
        <Text size="body2" color={Colors.v2.red}>
          {/* count > 1 selects the plural "New Messages" form */}
          {i18n('chat.newMessages', { count: 2 })}
        </Text>
      </View>
      <View flex>
        <MBSeparator color={Colors.v2.red} />
      </View>
    </View>
  );
}
